import { call, put, takeLatest } from 'redux-saga/effects';

import { psmAuditDigital, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';
import { getNotificationErrorMessage } from './helpers';

function* followUpGet({ payload: { auditId } }) {
  try {
    const { data } = yield call(dataProvider.getOnly, `audit/follow-up/${auditId}`, {});
    const followUp = (data && data.data) || data || null;
    yield put({ type: psmAuditDigital.followUpGet.end, payload: followUp });
  } catch (e) {
    yield put({ type: psmAuditDigital.followUpGet.error });
    yield put({
      type: notification.add,
      payload: { error: getNotificationErrorMessage(e, 'Failed to load follow-up') },
    });
  }
}

export default function* followUpGetSaga() {
  yield takeLatest(psmAuditDigital.followUpGet.start, followUpGet);
}
